import { Pipe, PipeTransform, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import siteConfig from '@app/site-config';
import { Utilities } from '@shared/utils/utilities';

@Pipe({
  name: 'countryCodesTranslate',
  standalone: true
})
export class CountryCodesTranslate implements PipeTransform {
  translateService = inject(TranslateService);

  constructor() { }
  transform(value: string[]): string {
    if (!value || value.length === 0) {
      return "";
    }

    return value
      .filter(item => !Utilities.isEmptyString(item))
      .map(item => this.translateService.instant(siteConfig.CountryCodeMapping[item]))
      .join(',');
  }
}
